package app.nestbridge.feature.children.presentation

import androidx.compose.runtime.Composable
import app.nestbridge.feature.children.screen.ChildrenEvent
import app.nestbridge.feature.children.screen.ChildrenScreen
import app.nestbridge.feature.children.screen.ChildrenState
import com.slack.circuit.codegen.annotations.CircuitInject
import com.slack.circuit.runtime.presenter.Presenter
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope

@CircuitInject(
    screen = ChildrenScreen::class,
    scope = AppScope::class,
)
class ChildrenPresenter @Inject constructor() : Presenter<ChildrenState> {

    @Composable
    override fun present(): ChildrenState {
        return ChildrenState(
            eventSink = { _: ChildrenEvent ->
                // No-op for now.
            },
        )
    }
}
